import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const AreaActive = (props: SvgIconT.Props) => (
  <SvgIcon
    {...props}
    viewBox="0 0 20 20"
    paths={[
      'M20 0l-5 8-6 4-4-3-5 3.57v3.38l4.95-2.02 4 1.46 6.95-2.26L20 8.49z',
      'M16.47 14l-7.54 2.45L4.97 15 0 17.03V20h20V10z',
    ]}
  />
);

export default AreaActive;
